import "./src/base/styles/main.css";

import React from "react";
import { MatchMediaProvider } from "@/context";

export const wrapRootElement = ({ element }) => {
  return <MatchMediaProvider>{element}</MatchMediaProvider>;
};
